

    
(function(root) {
    var factory = function($) {
        var Toggles = (root["Toggles"] = function(el, opts) {
            var self = this;

            if (typeof opts === "boolean" && el.data("toggles")) {
                el.data("toggles").toggle(opts);
                return;
            }

            var dataAttr = [
                "on",
                "drag",
                "click",
                "width",
                "height",
                "animate",
                "easing",
                "type",
                "checkbox"
            ];
            var dataOpts = {};
            for (var i = 0; i < dataAttr.length; i++) {
                var opt = el.data("toggle-" + dataAttr[i]);
                if (typeof opt !== "undefined") dataOpts[dataAttr[i]] = opt;
            }

            // extend default opts with the users options
            opts = $.extend(
                {
                    // can the toggle be dragged
                    drag: true,
                    // can it be clicked to toggle
                    click: true,
                    text: {
                        // text for the ON/OFF position
                        on: "ON",
                        off: "OFF"
                    },
                    // is the toggle ON on init
                    on: false,
                    // animation time (ms)
                    animate: 250,
                    // animation transition easing function,
                    easing: "swing",
                    // the checkbox to toggle (for use in forms)
                    checkbox: null,
                    // element that can be clicked on to toggle. removes binding from the toggle itself (use nesting)
                    clicker: null,
                    // width (falls back to 50px)
                    width: 0,
                    // height (falls back to 20px)
                    height: 0,
                    // defaults to a compact toggle, other option is 'select' where both options are shown at once
                    type: "compact",
                    // the event name to fire when we toggle
                    event: "toggle"
                },
                opts || {},
                dataOpts
            );

            el.data("toggles", self);

            // set active to the opposite of what we want, so toggle will run properly
            var active = !opts["on"];

            var selectType = opts["type"] === "select";

            // make checkbox a jquery element
            var checkbox = $(opts["checkbox"]);

            var clicker = opts["clicker"] && $(opts["clicker"]);

            var height = opts["height"] || el.height() || 20;
            var width = opts["width"] || el.width() || 50;

            el.height(height);
            el.width(width);

            var div = function(name) {
                return $('<div class="toggle-' + name + '">');
            };

            // wrapper inside toggle
            var elSlide = div("slide");
            // inside slide, this bit moves
            var elInner = div("inner");
            // the on/off divs
            var elOn = div("on");
            var elOff = div("off");
            // the grip to drag the toggle
            var elBlob = div("blob");

            var halfHeight = height / 2;
            var onOffWidth = width - halfHeight;

            var text = opts["text"];

            // set up the CSS for the individual elements
            elOn
                .css({
                    height: height,
                    width: onOffWidth,
                    textIndent: selectType ? "" : -height / 3,
                    lineHeight: height + "px"
                })
                .html('<span>'+text["on"]+'</span>');

            elOff
                .css({
                    height: height,
                    width: onOffWidth,
                    marginLeft: selectType ? "" : -halfHeight,
                    textIndent: selectType ? "" : height / 3,
                    lineHeight: height + "px"
                })
                .html('<span>'+text["off"]+'</span>');

            elBlob.css({
                height: height,
                width: height,
                marginLeft: -halfHeight
            });

            elInner.css({
                width: width * 2 - height,
                marginLeft: selectType ? 0 : -width + height
            });

            if (selectType) {
                elSlide.addClass("toggle-select");
                el.css("width", onOffWidth * 2);
                elBlob.hide();
            }

            // construct the toggle
            elInner.append(elOn, elBlob, elOff);
            elSlide.html(elInner);
            el.html(elSlide);

            var doToggle = (self.toggle = function(state, noAnimate, noEvent) {
                // check we arent already in the desired state
                if (active === state) return;

                active = self["active"] = !active;

                el.data("toggle-active", active);

                elOff.toggleClass("active", !active);
                elOn.toggleClass("active", active);
                checkbox.prop("checked", active);

                if (!noEvent) el.trigger(opts["event"], active);

                if (selectType) return;

                var margin = active ? 0 : -width + height;

                // move the toggle!
                elInner.stop().animate(
                    {
                        marginLeft: margin
                    },
                    noAnimate ? 0 : opts["animate"],
                    opts["easing"]
                );
            });

            // evt handler for click events
            var clickHandler = function(e) {
                // if the target isn't the blob or dragging is disabled, toggle!
                if (
                    !el.hasClass("disabled") &&
                    (e["target"] !== elBlob[0] || !opts["drag"])
                ) {
                    doToggle();
                }
            };

            // if click is enabled and toggle isn't within the clicker element (stops double binding)
            if (opts["click"] && (!clicker || !clicker.has(el).length)) {
                el.on("click", clickHandler);
            }

            // setup the clicker element
            if (clicker) {
                clicker.on("click", clickHandler);
            }

            // bind up dragging stuff
            if (opts["drag"] && !selectType) {
                // time to begin the dragging parts/blob clicks
                var diff;
                var slideLimit = (width - height) / 4;

                // fired on mouseup and mouseleave events
                var upLeave = function(e) {
                    el.off("mousemove");
                    elSlide.off("mouseleave");
                    elBlob.off("mouseup");

                    if (!diff && opts["click"] && e.type !== "mouseleave") {
                        doToggle();
                        return;
                    }

                    var overBound = active
                        ? diff < -slideLimit
                        : diff > slideLimit;
                    if (overBound) {
                        // dragged far enough, toggle
                        doToggle();
                    } else {
                        // reset to previous state
                        elInner.stop().animate(
                            {
                                marginLeft: active ? 0 : -width + height
                            },
                            opts["animate"] / 2,
                            opts["easing"]
                        );
                    }
                };

                var wh = -width + height;

                elBlob.on("mousedown", function(e) {
                    if (el.hasClass("disabled")) return;

                    // reset diff
                    diff = 0;

                    elBlob.off("mouseup");
                    elSlide.off("mouseleave");
                    var cursor = e.pageX;

                    el.on("mousemove", elBlob, function(e) {
                        diff = e.pageX - cursor;
                        var marginLeft;

                        if (active) {
                            marginLeft = diff;

                            // keep it within the limits
                            if (diff > 0) marginLeft = 0;
                            if (diff < wh) marginLeft = wh;
                        } else {
                            marginLeft = diff + wh;

                            if (diff < 0) marginLeft = wh;
                            if (diff > -wh) marginLeft = 0;
                        }

                        elInner.css("margin-left", marginLeft);
                    });

                    elBlob.on("mouseup", upLeave);
                    elSlide.on("mouseleave", upLeave);
                });
            }

            // toggle the toggle to the correct state with no animation and no event
            doToggle(opts["on"], true, true);
        });

        $.fn["toggles"] = function(opts) {
            return this.each(function() {
                new Toggles($(this), opts);
            });
        };
    };

    if (typeof define === "function" && define["amd"]) {
        define(["jquery"], factory);
    } else {
        factory(
            root["jQuery"] || root["Zepto"] || root["ender"] || root["$"] || $
        );
    }
})(this);

$(document).ready(function() {
    $(".toggle").toggles({
        drag: true,
        click: true,
        text: {
            on: "in",
            off: "cm"
        },
        on: true,
        animate: 250,
        easing: "swing",
        checkbox: null,
        clicker: null,
        width: 28,
        height: 15,
        type: "compact"
    });

    // Getting notified of changes, and the new state:
    $(".toggle-radio").on("toggle", function(e, active) {
        // Reset Value
        $('.drop-value').removeClass('unit-added')
        $('.inches-calculator .error').fadeOut('fast')
        $('.icentimeter-calculator .error').fadeOut('fast')
        $('.valtoadd .val').each(function(){
            var inches = $(this).data('inches');
            var cm = $(this).data('cm');
            var inches_range = $(this).data('range-inches');
            var cm_range = $(this).data('range-cm');
            const range = $('.calculator-container').data('range');
            if (active) {
                if (range){
                    $(this).text(inches_range);
                } else {
                    $(this).text(inches);
                }
                $(this).next().text('”')
                
            } else {
                if (range){
                    $(this).text(cm_range);
                } else {
                    $(this).text(cm);
                }
                $(this).next().text('cm')          
            }
        })
        $('.drop-value-feet').text('feet')
        $('.drop-value-inches').text('inches')
        $('.drop-value-centimeter').text('cm')
        if (active) {
          $("#radio_in").attr("checked", "checked");
          $("#radio_in").prop("checked", "checked");
          $('.inches-calculator').css('display','block');
          $('.centimeter-calculator').css('display','none');
          $('.screen-distance').text('20-30”');
        } else {
           $("#radio_cm").attr("checked", "checked");
           $("#radio_cm").prop("checked", "checked");
           $('.inches-calculator').css('display','none');
           $('.centimeter-calculator').css('display','block');
           $('.screen-distance').text('51-76cm');

        }
    });
});

const small_inche = `<span>0</span>
<span>1</span>
<span>2</span>
<span>3</span>
<span>4</span>
`;

const big_inche = `<span>0</span>
<span>1</span>
<span>2</span>
<span>3</span>
<span>4</span>
<span>5</span>
<span>6</span>
<span>7</span>
<span>8</span>
<span>9</span>
<span>10</span>
<span>11</span>`;

$(document).on('DOMSubtreeModified', '.drop-value-feet', function(){
    
    if($(this).text()=='6'){
        $('.drop-value-inches').closest('.dropdown-feet').find('.dropdown').html(small_inche);
        if($('.drop-value-inches').hasClass('unit-added')){
            $('.drop-value-inches').text('0')
        }
    } else{
        $('.drop-value-inches').closest('.dropdown-feet').find('.dropdown').html(big_inche) 
    }
})

$(document).on('click', '.dropdown-head', function(){
    $(this).next().slideToggle('fast')
})

$(document).on('click', '.dropdown span', function(){
    $('.inches-calculator .error').fadeOut('fast')
    $('.centimeter-calculator .error').fadeOut('fast')

  
  

    var value = $(this).text()
    var trimval = $.trim(value);
    $(this).closest('.dropdown-feet').find('.drop-value').text(trimval).addClass('unit-added')
    $(this).closest('.dropdown').find('span').removeClass('active-value');
    $(this).addClass('active-value');
    $(this).closest('.dropdown').slideUp('fast');
    $(this).closest('.dropdown-feet').attr('selected-value', value);
})

$(document).click((event) => {
    if (!$(event.target).closest('.dropdown-feet').length) {
        $('.dropdown').slideUp('fast');
    }        
  });



  $(document).on('click','.btn-result-in', function(){



    $(this).closest('.result-wrapper').addClass('nopopup')

    let result = false;

    $('.inches-calculator .drop-value').each(function(){
      if($(this).hasClass('unit-added')) {
          result = true;
      } else {
          result = false;
      }
    })

if(result){

    var feet_val = $('.drop-value-feet').text();
    var inch_val = $('.drop-value-inches').text();
    
    if(isNaN(feet_val)||isNaN(inch_val)){
		alert("One or more inputs is invalid");
		return false;
	}

    oin = ((feet_val * 12) + (inch_val * 1) * 1);
	oinches = (oin);
	if(oinches==0){
		alert("Please enter valid values into the boxes");
	} 

    
    var finalVal = parseInt(oinches).toFixed(2).replace(/\.0+$/,'')
    console.log(finalVal)


    var valarray = [];
    valarray.push({inches : "60", monitorHeightSeated : "43", DeskHeightSeated : "23", SeatHeightSeated : "16", MonitorHeightStanding : "57", DeskHeightStanding : "39" })
    valarray.push({inches : "61", monitorHeightSeated : "44", DeskHeightSeated : "23", SeatHeightSeated : "16", MonitorHeightStanding : "58", DeskHeightStanding : "39" })
    valarray.push({inches : "62", monitorHeightSeated : "44", DeskHeightSeated : "24", SeatHeightSeated : "16", MonitorHeightStanding : "59", DeskHeightStanding : "40" })
    valarray.push({inches : "63", monitorHeightSeated : "45", DeskHeightSeated : "24", SeatHeightSeated : "16", MonitorHeightStanding : "60", DeskHeightStanding : "40" })
    valarray.push({inches : "64", monitorHeightSeated : "46", DeskHeightSeated : "25", SeatHeightSeated : "16", MonitorHeightStanding : "61", DeskHeightStanding : "41" })
    valarray.push({inches : "65", monitorHeightSeated : "47", DeskHeightSeated : "25", SeatHeightSeated : "17", MonitorHeightStanding : "62", DeskHeightStanding : "42" })
    valarray.push({inches : "66", monitorHeightSeated : "47", DeskHeightSeated : "26", SeatHeightSeated : "17", MonitorHeightStanding : "63", DeskHeightStanding : "43" })
    valarray.push({inches : "67", monitorHeightSeated : "48", DeskHeightSeated : "26", SeatHeightSeated : "17", MonitorHeightStanding : "64", DeskHeightStanding : "43" })
    valarray.push({inches : "68", monitorHeightSeated : "49", DeskHeightSeated : "26", SeatHeightSeated : "18", MonitorHeightStanding : "65", DeskHeightStanding : "44" })
    valarray.push({inches : "69", monitorHeightSeated : "50", DeskHeightSeated : "27", SeatHeightSeated : "18", MonitorHeightStanding : "66", DeskHeightStanding : "45" })
    valarray.push({inches : "70", monitorHeightSeated : "50", DeskHeightSeated : "27", SeatHeightSeated : "18", MonitorHeightStanding : "67", DeskHeightStanding : "45" })
    valarray.push({inches : "71", monitorHeightSeated : "51", DeskHeightSeated : "28", SeatHeightSeated : "18", MonitorHeightStanding : "68", DeskHeightStanding : "46" })
    valarray.push({inches : "72", monitorHeightSeated : "52", DeskHeightSeated : "28", SeatHeightSeated : "18", MonitorHeightStanding : "69", DeskHeightStanding : "47" })
    valarray.push({inches : "73", monitorHeightSeated : "52", DeskHeightSeated : "29", SeatHeightSeated : "18", MonitorHeightStanding : "69", DeskHeightStanding : "47" })
    valarray.push({inches : "74", monitorHeightSeated : "53", DeskHeightSeated : "29", SeatHeightSeated : "19", MonitorHeightStanding : "70", DeskHeightStanding : "48" })
    valarray.push({inches : "75", monitorHeightSeated : "54", DeskHeightSeated : "29", SeatHeightSeated : "20", MonitorHeightStanding : "71", DeskHeightStanding : "49" })
    valarray.push({inches : "76", monitorHeightSeated : "55", DeskHeightSeated : "30", SeatHeightSeated : "20", MonitorHeightStanding : "72", DeskHeightStanding : "50" })
    

     $.each( valarray, function( i, unit ) {
        var inches = valarray[i].inches,
        monitorHeightSeated = valarray[i].monitorHeightSeated,
        DeskHeightSeated = valarray[i].DeskHeightSeated,
        SeatHeightSeated = valarray[i].SeatHeightSeated,
        MonitorHeightStanding = valarray[i].MonitorHeightStanding,
        DeskHeightStanding = valarray[i].DeskHeightStanding;  
        if (finalVal==inches) {
        const range = $('.calculator-container').data('range');
        const amount = parseInt($('.calculator-container').data('range-amount'));

            var monitorHeightseated_cm = parseInt(monitorHeightSeated/0.39370).toFixed(0).replace(/\.0+$/,'');
            var monitorHeightSeatedRange_cm = `${parseInt((parseInt(monitorHeightSeated)- amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(monitorHeightSeated)+ amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}`;
            var monitorHeightSeatedRange_inches = `${parseInt(monitorHeightSeated) - amount}-${parseInt(monitorHeightSeated) + amount}`;
            var monitorHeightSeatedInnerHtml = range ? monitorHeightSeatedRange_inches : monitorHeightSeated;
            $('.monitor-height-seated').html('<span class="val" data-range-inches="'+monitorHeightSeatedRange_inches+'" data-range-cm="'+monitorHeightSeatedRange_cm+'" data-cm="'+monitorHeightseated_cm+'" data-inches="'+monitorHeightSeated+'">'+monitorHeightSeatedInnerHtml+'</span><article>”</article>');

            var DeskHeightSeated_cm = parseInt(DeskHeightSeated/0.39370).toFixed(0).replace(/\.0+$/,'');
            var deskHeightSeatedRange_cm = `${parseInt((parseInt(DeskHeightSeated)- amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(DeskHeightSeated)+ amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}`;
            var deskHeightSeatedRange_inches = `${parseInt(DeskHeightSeated) - amount}-${parseInt(DeskHeightSeated) + amount}`;
            var deskHeightSeatedInnerHtml = range ? deskHeightSeatedRange_inches : DeskHeightSeated;
            $('.desk-height-seated').html('<span class="val" data-range-inches="'+deskHeightSeatedRange_inches+'" data-range-cm="'+deskHeightSeatedRange_cm+'" data-cm="'+DeskHeightSeated_cm+'" data-inches="'+DeskHeightSeated+'">'+deskHeightSeatedInnerHtml+'</span><article>”</article>');

            var SeatHeightSeated_cm = parseInt(SeatHeightSeated/0.39370).toFixed(0).replace(/\.0+$/,'');
            var seatHeightSeatedRange_cm = `${parseInt((parseInt(SeatHeightSeated)- amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(SeatHeightSeated)+ amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}`;
            var seatHeightSeatedRange_inches = `${parseInt(SeatHeightSeated) - amount}-${parseInt(SeatHeightSeated) + amount}`;
            var seatHeightSeatedInnerHtml = range ? seatHeightSeatedRange_inches : SeatHeightSeated;
            $('.seat-height').html('<span class="val" data-cm="'+SeatHeightSeated_cm+'" data-range-inches="'+seatHeightSeatedRange_inches+'" data-range-cm="'+seatHeightSeatedRange_cm+'"  data-inches="'+SeatHeightSeated+'">'+seatHeightSeatedInnerHtml+'</span><article>”</article>');

            var MonitorHeightStanding_cm = parseInt(MonitorHeightStanding/0.39370).toFixed(0).replace(/\.0+$/,'');
            var monitorHeightStandingRange_cm = `${parseInt((parseInt(MonitorHeightStanding)- amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(MonitorHeightStanding)+ amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}`;
            var monitorHeightStandingRange_inches = `${parseInt(MonitorHeightStanding) - amount}-${parseInt(MonitorHeightStanding) + amount}`;
            var monitorHeightStandingInnerHtml = range ? monitorHeightStandingRange_inches : MonitorHeightStanding;
            $('.monitor-height-standing').html('<span class="val" data-range-inches="'+monitorHeightStandingRange_inches+'" data-range-cm="'+monitorHeightStandingRange_cm+'" data-cm="'+SeatHeightSeated_cm+'" data-range-inches="'+seatHeightSeatedRange_inches+'"data-cm="'+MonitorHeightStanding_cm+'" data-inches="'+MonitorHeightStanding+'">'+monitorHeightStandingInnerHtml+'</span><article>”</article>');

            var DeskHeightStanding_cm = parseInt(DeskHeightStanding/0.39370).toFixed(0).replace(/\.0+$/,'');
            var deskHeightStandingRange_cm = `${parseInt((parseInt(DeskHeightStanding)- amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(DeskHeightStanding)+ amount)/0.39370).toFixed(0).replace(/\.0+$/,'')}`;
            var deskHeightStandingRange_inches = `${parseInt(DeskHeightStanding) - amount}-${parseInt(DeskHeightStanding) + amount}`;
            var deskHeightStandingInnerHtml = range ? deskHeightStandingRange_inches : DeskHeightStanding;
            $('.desk-height-standing').html('<span class="val" data-range-inches="'+deskHeightStandingRange_inches+'" data-range-cm="'+deskHeightStandingRange_cm+'" data-cm="'+DeskHeightStanding_cm+'" data-inches="'+DeskHeightStanding+'">'+deskHeightStandingInnerHtml+'</span><article>”</article>');


        }
      });

      $('.inches-calculator .error').fadeOut('fast')

} else {
    $('.inches-calculator .error').fadeIn('fast')
}

})

$(document).on('click','.btn-result-cm', function(){
    $(this).closest('.result-wrapper').addClass('nopopup')
    
    let result = false;

    $('.centimeter-calculator .drop-value').each(function(){
      if($(this).hasClass('unit-added')) {
          result = true;
      } else {
          result = false;
      }
    })
    if(result){

        var valarray = [];

        valarray.push({cm : "150", monitorHeightSeated : "109", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "145", DeskHeightStanding : "99" })
        valarray.push({cm : "151", monitorHeightSeated : "109", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "145", DeskHeightStanding : "99" })
        valarray.push({cm : "152", monitorHeightSeated : "109", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "145", DeskHeightStanding : "99" })
        valarray.push({cm : "153", monitorHeightSeated : "109", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "145", DeskHeightStanding : "99" })
        valarray.push({cm : "154", monitorHeightSeated : "112", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "147", DeskHeightStanding : "99" })
        valarray.push({cm : "155", monitorHeightSeated : "112", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "147", DeskHeightStanding : "99" })
        valarray.push({cm : "156", monitorHeightSeated : "112", DeskHeightSeated : "58", SeatHeightSeated : "41", MonitorHeightStanding : "147", DeskHeightStanding : "99" })
        valarray.push({cm : "157", monitorHeightSeated : "112", DeskHeightSeated : "61", SeatHeightSeated : "41", MonitorHeightStanding : "150", DeskHeightStanding : "102" })
        valarray.push({cm : "158", monitorHeightSeated : "112", DeskHeightSeated : "61", SeatHeightSeated : "41", MonitorHeightStanding : "150", DeskHeightStanding : "102" })
        valarray.push({cm : "159", monitorHeightSeated : "114", DeskHeightSeated : "61", SeatHeightSeated : "41", MonitorHeightStanding : "152", DeskHeightStanding : "102" })
        valarray.push({cm : "160", monitorHeightSeated : "114", DeskHeightSeated : "61", SeatHeightSeated : "41", MonitorHeightStanding : "152", DeskHeightStanding : "102" })
        valarray.push({cm : "161", monitorHeightSeated : "114", DeskHeightSeated : "61", SeatHeightSeated : "41", MonitorHeightStanding : "152", DeskHeightStanding : "102" })
        valarray.push({cm : "162", monitorHeightSeated : "117", DeskHeightSeated : "64", SeatHeightSeated : "41", MonitorHeightStanding : "155", DeskHeightStanding : "104" })
        valarray.push({cm : "163", monitorHeightSeated : "117", DeskHeightSeated : "64", SeatHeightSeated : "41", MonitorHeightStanding : "155", DeskHeightStanding : "104" })
        valarray.push({cm : "164", monitorHeightSeated : "119", DeskHeightSeated : "64", SeatHeightSeated : "43", MonitorHeightStanding : "157", DeskHeightStanding : "107" })
        valarray.push({cm : "165", monitorHeightSeated : "119", DeskHeightSeated : "64", SeatHeightSeated : "43", MonitorHeightStanding : "157", DeskHeightStanding : "107" })
        valarray.push({cm : "166", monitorHeightSeated : "119", DeskHeightSeated : "64", SeatHeightSeated : "43", MonitorHeightStanding : "157", DeskHeightStanding : "107" })
        valarray.push({cm : "167", monitorHeightSeated : "119", DeskHeightSeated : "66", SeatHeightSeated : "43", MonitorHeightStanding : "160", DeskHeightStanding : "109" })
        valarray.push({cm : "168", monitorHeightSeated : "119", DeskHeightSeated : "66", SeatHeightSeated : "43", MonitorHeightStanding : "160", DeskHeightStanding : "109" })
        valarray.push({cm : "169", monitorHeightSeated : "122", DeskHeightSeated : "66", SeatHeightSeated : "43", MonitorHeightStanding : "163", DeskHeightStanding : "109" })
        valarray.push({cm : "170", monitorHeightSeated : "122", DeskHeightSeated : "66", SeatHeightSeated : "43", MonitorHeightStanding : "163", DeskHeightStanding : "109" })
        valarray.push({cm : "171", monitorHeightSeated : "122", DeskHeightSeated : "66", SeatHeightSeated : "43", MonitorHeightStanding : "163", DeskHeightStanding : "109" })
        valarray.push({cm : "172", monitorHeightSeated : "124", DeskHeightSeated : "66", SeatHeightSeated : "46", MonitorHeightStanding : "165", DeskHeightStanding : "112" })
        valarray.push({cm : "173", monitorHeightSeated : "124", DeskHeightSeated : "66", SeatHeightSeated : "46", MonitorHeightStanding : "165", DeskHeightStanding : "112" })
        valarray.push({cm : "174", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "168", DeskHeightStanding : "114" })
        valarray.push({cm : "175", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "168", DeskHeightStanding : "114" })
        valarray.push({cm : "176", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "168", DeskHeightStanding : "114" })
        valarray.push({cm : "177", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "170", DeskHeightStanding : "114" })
        valarray.push({cm : "178", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "170", DeskHeightStanding : "114" })
        valarray.push({cm : "179", monitorHeightSeated : "127", DeskHeightSeated : "69", SeatHeightSeated : "46", MonitorHeightStanding : "170", DeskHeightStanding : "114" })
        valarray.push({cm : "180", monitorHeightSeated : "130", DeskHeightSeated : "71", SeatHeightSeated : "46", MonitorHeightStanding : "173", DeskHeightStanding : "117" })
        valarray.push({cm : "181", monitorHeightSeated : "130", DeskHeightSeated : "71", SeatHeightSeated : "46", MonitorHeightStanding : "173", DeskHeightStanding : "117" })
        valarray.push({cm : "182", monitorHeightSeated : "132", DeskHeightSeated : "71", SeatHeightSeated : "46", MonitorHeightStanding : "175", DeskHeightStanding : "119" })
        valarray.push({cm : "183", monitorHeightSeated : "132", DeskHeightSeated : "71", SeatHeightSeated : "46", MonitorHeightStanding : "175", DeskHeightStanding : "119" })
        valarray.push({cm : "184", monitorHeightSeated : "132", DeskHeightSeated : "71", SeatHeightSeated : "46", MonitorHeightStanding : "175", DeskHeightStanding : "119" })
        valarray.push({cm : "185", monitorHeightSeated : "132", DeskHeightSeated : "74", SeatHeightSeated : "46", MonitorHeightStanding : "175", DeskHeightStanding : "119" })



        var centimeter = $('.drop-value-centimeter').text();
        console.log(centimeter)

        $.each( valarray, function( i, unit ) {
            var cm = valarray[i].cm,
            monitorHeightSeated = valarray[i].monitorHeightSeated,
            DeskHeightSeated = valarray[i].DeskHeightSeated,
            SeatHeightSeated = valarray[i].SeatHeightSeated,
            MonitorHeightStanding = valarray[i].MonitorHeightStanding,
            DeskHeightStanding = valarray[i].DeskHeightStanding;  
            if (centimeter==cm) {
                const range = $('.calculator-container').data('range');
                const amount = parseInt($('.calculator-container').data('range-amount'));

                var monitorHeightseated_in = parseInt(monitorHeightSeated*0.39370).toFixed(0).replace(/\.0+$/,'');
                var monitorHeightSeatedRange_cm = `${parseInt((parseInt(monitorHeightSeated)-(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(monitorHeightSeated)+(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}`;
                var monitorHeightSeatedRange_inches = `${parseInt(parseInt(monitorHeightSeated) * 0.39370) - amount}-${parseInt(parseInt(monitorHeightSeated) * 0.39370) + amount}`;
                var monitorHeightSeatedInnerHtml = range ? monitorHeightSeatedRange_cm : monitorHeightSeated;
                $('.monitor-height-seated').html('<span class="val" data-range-inches="'+monitorHeightSeatedRange_inches+'" data-range-cm="'+monitorHeightSeatedRange_cm+'" data-cm="'+monitorHeightSeated+'" data-inches="'+monitorHeightseated_in+'">'+monitorHeightSeatedInnerHtml+'</span><article>cm</article>');
    
                var DeskHeightSeated_in = parseInt(DeskHeightSeated*0.39370).toFixed(0).replace(/\.0+$/,'');
                var deskHeightSeatedRange_cm = `${parseInt((parseInt(DeskHeightSeated)-(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(DeskHeightSeated)+(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}`;
                var deskHeightSeatedRange_inches = `${parseInt(parseInt(DeskHeightSeated) * 0.39370) - amount}-${parseInt(parseInt(DeskHeightSeated) * 0.39370) + amount}`;
                var deskHeightSeatedInnerHtml = range ? deskHeightSeatedRange_cm : DeskHeightSeated;
                $('.desk-height-seated').html('<span class="val" data-range-inches="'+deskHeightSeatedRange_inches+'" data-range-cm="'+deskHeightSeatedRange_cm+'" data-cm="'+DeskHeightSeated+'" data-inches="'+DeskHeightSeated_in+'">'+deskHeightSeatedInnerHtml+'</span><article>cm</article>');
    
                var SeatHeightSeated_in = parseInt(SeatHeightSeated*0.39370).toFixed(0).replace(/\.0+$/,'');
                var seatHeightSeatedRange_cm = `${parseInt((parseInt(SeatHeightSeated)-(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(SeatHeightSeated)+(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}`;
                var seatHeightSeatedRange_inches = `${parseInt(parseInt(SeatHeightSeated) * 0.39370) - amount}-${parseInt(parseInt(SeatHeightSeated) * 0.39370) + amount}`;
                var seatHeightSeatedInnerHtml = range ? seatHeightSeatedRange_cm : SeatHeightSeated;
                $('.seat-height').html('<span class="val" data-range-inches="'+seatHeightSeatedRange_inches+'" data-range-cm="'+seatHeightSeatedRange_cm+'" data-cm="'+SeatHeightSeated+'" data-inches="'+SeatHeightSeated_in+'">'+seatHeightSeatedInnerHtml+'</span><article>cm</article>');
    
                var MonitorHeightStanding_in = parseInt(MonitorHeightStanding*0.39370).toFixed(0).replace(/\.0+$/,'');
                var monitorHeightStandingRange_cm = `${parseInt((parseInt(MonitorHeightStanding)-(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(MonitorHeightStanding)+(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}`;
                var monitorHeightStandingRange_inches = `${parseInt(parseInt(MonitorHeightStanding) * 0.39370) - amount}-${parseInt(parseInt(MonitorHeightStanding) * 0.39370) + amount}`;
                var monitorHeightStandingInnerHtml = range ? monitorHeightStandingRange_cm : MonitorHeightStanding;
                $('.monitor-height-standing').html('<span class="val" data-range-inches="'+monitorHeightStandingRange_inches+'" data-range-cm="'+monitorHeightStandingRange_cm+'" data-cm="'+MonitorHeightStanding+'" data-inches="'+MonitorHeightStanding_in+'">'+monitorHeightStandingInnerHtml+'</span><article>cm</article>');
    
                var DeskHeightStanding_in = parseInt(DeskHeightStanding*0.39370).toFixed(0).replace(/\.0+$/,'');
                var deskHeightStandingRange_cm = `${parseInt((parseInt(DeskHeightStanding)-(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}-${parseInt((parseInt(DeskHeightStanding)+(amount * 2.53999))).toFixed(0).replace(/\.0+$/,'')}`;
                var deskHeightStandingRange_inches = `${parseInt(parseInt(DeskHeightStanding) * 0.39370) - amount}-${parseInt(parseInt(DeskHeightStanding) * 0.39370) + amount}`;
                var deskHeightStandingInnerHtml = range ? deskHeightStandingRange_cm : DeskHeightStanding;
                $('.desk-height-standing').html('<span class="val" data-range-inches="'+deskHeightStandingRange_inches+'" data-range-cm="'+deskHeightStandingRange_cm+'" data-cm="'+DeskHeightStanding+'" data-inches="'+DeskHeightStanding_in+'">'+deskHeightStandingInnerHtml+'</span><article>cm</article>');
    
    
            }
          });







        $('.centimeter-calculator .error').fadeOut('fast')
} else {
    $('.centimeter-calculator .error').fadeIn('fast')
}
})






$(function(){
    $("#btn_convert").click(function(){
       html2canvas($("#main"), {
          onrendered: function(canvas) {
             var imgsrc = canvas.toDataURL("image/png");
             console.log(imgsrc);
             
          }
       });
    });  
    });
